import { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useAuthContext } from '../../../contexts/AuthContext';

import useSetBackgroundColor from '../../../utils/hooks/useSetBackgroundColor';
import LoadingNova from '../../Global/Atomics/LoadingNova';

export const ProtectedRoute = ({ redirectPath = '/' }) => {
    const [isLoading, setIsLoading] = useState(true);
    const { userData, isLogging } = useAuthContext();
    useSetBackgroundColor();

    // Make sure to only show protected pages when user object is not null
    useEffect(() => {
        setIsLoading(false);
    }, [userData]);

    if (isLogging || isLoading) {
        return <LoadingNova />
    }

    if (!userData) {
        return <Navigate to={redirectPath} replace />;
    }

    return (
        <>
            <Outlet />
        </>
    )
}